import { Box, Typography, useTheme } from "@mui/material";
import { PropertyTrack } from "../../../types";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import usePassport from "@/modules/common/hooks/passport";
import {
  Permission,
  PermissionLevel,
  PermissionsEnum,
} from "@/modules/common/types";
import { isLevelAllowed } from "@/modules/common/utils";

export default function TrackContainer({ track }: { track: PropertyTrack }) {
  const theme = useTheme();

  const { permissions } = usePassport();

  const permission: Permission = {
    name: PermissionsEnum.VIEW_ALL_TRACKS,
    level: PermissionLevel.READ,
  };

  const canViewAllTracks = !!permissions?.some(
    (userPermission) =>
      userPermission.name === permission.name &&
      isLevelAllowed({
        currentLevel: userPermission.level,
        requiredLevel: permission.level,
      })
  );
  const boxProps = canViewAllTracks && {
    component: Link,
    to: `/property-tracks/${track.uid}`,
    target: "_blank",
  };
  return (
    <Box
      {...boxProps}
      sx={(theme) => ({
        width: "200px",
        textDecoration: "none",
        backgroundColor: theme.nawy.colors.semantic.layer.secondary,
        borderRadius: theme.nawy.radius.lg,
        p: theme.nawy.spacing.sm,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        cursor: canViewAllTracks ? "pointer" : "default",
      })}
    >
      <Box
        sx={(theme) => ({
          display: "flex",
          flexDirection: "column",
          gap: theme.nawy.spacing.xxs,
        })}
      >
        <Typography
          sx={(theme) => ({
            ...theme.nawy.typography.english.variants.body.md.semibold,
            color: theme.nawy.colors.semantic.text.primary,
            textDecoration: "none",
          })}
        >
          {track.trackStage?.trackType.name}
        </Typography>

        <Typography
          sx={(theme) => ({
            ...theme.nawy.typography.english.variants.body.sm.regular,
            color: theme.nawy.colors.semantic.text.secondary,
          })}
        >
          Stage: {track.trackStage?.name}
        </Typography>
      </Box>

      {canViewAllTracks && (
        <ChevronRight
          size={16}
          color={theme.nawy.colors.semantic.layer.primaryInverse}
        />
      )}
    </Box>
  );
}
